import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Modal, Col, Row, Form, Button } from '_zari/core'

import * as TablasComunesService from 'services/tablasComunes.service'

import * as FormGroups from './formGroups'

const ImportarModal = ({ show, handleClose }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    return {
      file: ''
    }
  }, [])

  const onSubmit = React.useCallback(
    data => {
      const submitData = new FormData()
      submitData.append('file', data.file)

      TablasComunesService.importarPlantilla(submitData)
        .then(() => {
          __zariContext.snack('success', 'Se han procesado los registros.')
          handleClose()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext, handleClose]
  )

  return (
    <Modal show={show}>
      <Modal.Header>
        <Modal.Title>Importar Plantilla</Modal.Title>
      </Modal.Header>
      <Formik onSubmit={onSubmit} initialValues={formInitialValues}>
        {({ setFieldValue, handleSubmit }) => (
          <>
            <Form>
              <Modal.Body>
                <Row>
                  <Col md={12}>
                    <FormGroups.FileFormGroup setFieldValue={setFieldValue} />
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button color='secondary' onClick={handleClose}>
                  Cancelar
                </Button>
                <Button onClick={handleSubmit}>Importar</Button>
              </Modal.Footer>
            </Form>
          </>
        )}
      </Formik>
    </Modal>
  )
}

export default React.memo(ImportarModal)
